import { render, staticRenderFns } from "./collapsingelement.vue?vue&type=template&id=07f1765c&"
import script from "./../../ts/projecttablerows/collaspingelement.ts?vue&type=script&lang=js&"
export * from "./../../ts/projecttablerows/collaspingelement.ts?vue&type=script&lang=js&"
import style0 from "./../../assets/css/projecttablerows/collapsingelement.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports